import * as SeparatorPrimitive from "@radix-ui/react-separator";
import clsx from "clsx";
import { base, dividerWithText, orientationVariants } from "./Divider.css";

type Orientation = "horizontal" | "vertical";

export interface DividerProps {
  /**
   * The orientation of the divider.
   */
  orientation?: Orientation;

  /**
   * The text to display in the divider (if any).
   * This will be displayed only when the orientation is horizontal.
   */
  text?: string;
}

export function Divider({ orientation = "horizontal", text }: DividerProps) {
  const isHorizontal = orientation === "horizontal";
  const hasText = Boolean(text?.trim()) && isHorizontal;

  return hasText ? (
    <SeparatorPrimitive.Root
      className={dividerWithText}
      role="separator"
      orientation="horizontal"
    >
      {text}
    </SeparatorPrimitive.Root>
  ) : (
    <SeparatorPrimitive.Root
      role="separator"
      orientation={orientation}
      className={clsx(
        base,
        orientationVariants[orientation as "horizontal" | "vertical"]
      )}
    />
  );
}
